import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { IHeroGradientBackground } from '../../_shared/models/hero/hero-gradient-background.model';
import { IMediaItem } from '../../_shared/models/media/media-item.model';
import { ImageDataDb } from '../../_shared/data/image-data-db.data';
import { getBackgroundColorClass, isLightBackgroundColor } from '../../_shared/data/hero-background-colors.data';
import { BackgroundVariant } from '../../_shared/models/hero/hero-variant.enum';
import { HeroBase } from '../hero-base.directive';
import { GridComponent } from '../../grid/grid.component';
import { HeadingComponent } from '../../heading/heading.component';

import { ButtonComponent } from '../../button/button.component';
import { ImageItemComponent } from '../../media/media-item/image-item/image-item.component';
import { LinkDirective } from '../../_shared/directives/link.directive';
import { CastPipe } from '../../_shared/pipes/cast.pipe';
import { TextHtmlComponent } from '../../text-html/text-html.component';

@Component({
    selector: 'sirius-hero-gradient-background',
    templateUrl: './hero-gradient-background.component.html',
    styleUrls: ['./hero-gradient-background.component.scss', '../hero.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    GridComponent,
    HeadingComponent,
    ButtonComponent,
    LinkDirective,
    ImageItemComponent,
    CastPipe,
    TextHtmlComponent
]
})
export class HeroGradientBackgroundComponent extends HeroBase implements OnInit, OnChanges, OnDestroy {
    @Input() color = '';
    @Input() image?: IMediaItem = {
        type: 'image',
        title: '',
    };

    config?: IHeroGradientBackground;

    get backgroundColor(): string | undefined {
        return getBackgroundColorClass(this.color, this.variant === BackgroundVariant.LIGHT);
    }

    ngOnInit(): void {
        if (this.config) {
            this.title = this.config.title;
            this.textHtml = this.config.textHtml;
            this.buttonPrimary = this.config.buttonPrimary;
            this.buttonSecondary = this.config.buttonSecondary;
            this.color = this.config.color;
            this.image = this.config.image;
        }

        this.updateVariant();
        this.imageData = ImageDataDb.hero.gradient;
    }

    override ngOnChanges(changes: SimpleChanges): void {
        if (changes['color'] && !changes['color'].firstChange) {
            this.updateVariant();
        }
    }

    private updateVariant(): void {
        const isLight = isLightBackgroundColor(this.color);
        this.variant = isLight ? BackgroundVariant.LIGHT : BackgroundVariant.DARK;

        this._breadcrumbService.setVariant(this.variant);
    }
}
